<template>
    <div>
        <v-tabs v-model="selectedTab" align-tabs="center" color="deep-pink-accent-4">
            <v-tab :value="1">{{ previousMonth }}</v-tab>
            <v-tab :value="2">{{ currentMonth }}</v-tab>
            <v-tab :value="3" :disabled="true">
                {{nextMonth}} Content in {{ daysUntil20th }} Days!
            </v-tab>
            <v-tab :value="4">
                Additional Content
            </v-tab>
        </v-tabs>
        <!-- Display assets based on the selected month and theme -->
        <v-container fluid>
            <v-row>
                <v-col v-for="(design, index) in displayedDesigns" :key="index" cols="12" md="4">
                    <v-card @click="openDesign(design.url, design.category)" class="mx-auto" outlined>
                        <!-- Display the thumbnail if available, otherwise display an icon -->
                        <v-img v-if="design.thumbnail" :src="design.thumbnail" height="205" cover></v-img>
                        <div v-else class="icon-container">
                            <v-icon :icon="design.icon" class="large-icon"></v-icon>
                        </div>

                        <v-card-title class="d-flex justify-space-between">
                            {{ design.title }}
                            <font-awesome-icon v-if="design.platform === 'Instagram'" :icon="['fab', 'instagram']" title="Instagram"  class="ml-auto"/>
                            <font-awesome-icon v-else-if="design.platform === 'Facebook'"  :icon="['fab', 'facebook']" title="Facebook" class="ml-auto"/>
                            <font-awesome-icon v-else-if="design.platform === 'YouTube'"  :icon="['fab', 'youtube']" title="YouTube" class="ml-auto"/>
                            <font-awesome-icon v-else-if="design.platform === 'TikTok'"  :icon="['fab', 'tiktok']" title="TikTok" class="ml-auto"/>
                            <font-awesome-icon v-else-if="design.platform === 'X'"  :icon="['fab', 'x-twitter']" title="X-Twitter" class="ml-auto"/>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-subtitle>{{ design.subtitle }}</v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        
    </div>
  </template>
  
  <script>
    import content from '@/assets/monthly-content.js'; 
    import additionalContent from '@/assets/additional-content.js';

    export default {
        name: 'PinkDoor',
        data: () => ({
            selectedTab: 2,
            content, 
            additionalContent,
            previousMonth: '',
            currentMonth: '',
            nextMonth: '',
            daysUntil20th: 0,
        }),
        mounted() {
            this.setMonthNames();
            this.setDaysUntil20th();
        },
        computed: {
            filteredDesigns() {
                let monthContent;
                if (this.selectedTab === 1) {
                    monthContent = this.content.previousMonth;
                } else if (this.selectedTab === 2) {
                    monthContent = this.content.currentMonth;
                } else if (this.selectedTab === 3) {
                    monthContent = this.content.nextMonth;
                } 
                return monthContent.filter(design => (design.theme === this.selectedTheme.id || design.theme === null));
            },
            displayedDesigns() {
                if (this.selectedTab === 4) {
                    return this.additionalContent;
                } else {
                    return this.filteredDesigns;
                }
            },
        },
        methods: {
            openDesign(url, category) {
                if (url) {
                    window.open(url, '_blank');
                } else {
                    var selectedMonth = this.currentMonth;
                    if (this.selectedTab === 1) {
                        selectedMonth = this.previousMonth;
                    }
                    this.$router.push({ 
                        name: category,
                        query: {
                            targetType: selectedMonth,
                            previousMonth: this.previousMonth,
                            currentMonth: this.currentMonth,
                            region: this.selectedTheme.region,
                        }
                    });  
                }
            },
            setMonthNames() {
                const today = new Date();
                const currentMonthIndex = today.getMonth();
                const dayOfMonth = today.getDate();
                
                // If today is the 20th or later, the "current" month shifts to the next one
                let previousMonthIndex, currentMonthIndexShifted;

                if (dayOfMonth >= 20) {
                    previousMonthIndex = currentMonthIndex; // Show current physical month as "previous"
                    currentMonthIndexShifted = (currentMonthIndex + 1) % 12; // Next physical month becomes the "current"
                } else {
                    previousMonthIndex = (currentMonthIndex - 1 + 12) % 12; // Previous physical month is shown as "previous"
                    currentMonthIndexShifted = currentMonthIndex; // Current physical month remains "current"
                }
                const nextMonthIndex = (currentMonthIndexShifted + 1) % 12;

                const monthNames = [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ];

                this.previousMonth = monthNames[previousMonthIndex];
                this.currentMonth = monthNames[currentMonthIndexShifted];
                this.nextMonth = monthNames[nextMonthIndex];
            },
            setDaysUntil20th() {
                const today = new Date();
                const dayOfMonth = today.getDate();
                const currentYear = today.getFullYear();
                let targetDate;

                if (dayOfMonth >= 20) {
                    // If today is the 20th or later, target the 20th of the next month
                    targetDate = new Date(currentYear, today.getMonth() + 1, 20);
                } else {
                    // If today is before the 20th, target the 20th of the current month
                    targetDate = new Date(currentYear, today.getMonth(), 20);
                }

                const diffTime = targetDate - today;
                this.daysUntil20th = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
            },
        },
        props: {
            selectedTheme: {
                type: Object,
                default: () => ({}),
            },
        },
    }
  </script>
  
<style scoped>
    .icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 205px;  /* Match the height of the v-img */
        background-color: #FACCC7; /* Optional: Give a background to the icon */
        /* Dark Pink: F8AFA6 */
    }

    .large-icon {
        font-size: 205px;  /* Adjust the size of the MDI icon */
        color: #fff;  /* Optional: Change the color of the icon */
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);  /* Customize the shadow as needed */
    }

  .v-card-title {
    padding: 16px 16px 8px;  /* Padding around the title */
  }

  .v-card-subtitle {
    padding: 4px 16px 4px;  /* Padding around the subtitle */
  }
</style>